import React from 'react';
import AnimationRevealPage from 'helpers/AnimationRevealPage.js';
import FAQ from 'components/faqs/SimpleWithSideImage.js';
import Footer from 'components/footers/MiniCenteredFooter.js';
import NavBar from 'components/navbars/basic.js';
import Teams from '../components/cards/ProfileThreeColGrid.js';

export default () => (
  <AnimationRevealPage>
    <NavBar />
    <FAQ />
    <Teams />
    <Footer />
  </AnimationRevealPage>
);
